<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qS0uKb/tc-custom/9781504066150.jpg?1728259374356" alt="This image is the cover for the book Keeper of the Bees"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Keeper of the Bees
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A wounded veteran discovers the healing power of nature in this classic American novel by the author of <i>A Girl of the Limberlost</i>.</b></p><p>Wounded in World War I, Jamie McFarlane is looking for a peaceful place to spend his final days. After escaping the grim confines of a California military hospital, he finds himself at the seaside home of the Bee Master. There, with the help of an impish eleven-year-old called Little Scout, Jamie tends to the hives and flowers while the Bee Master is away.</p> As Jamie learns his new responsibilities, he discovers a source of hope and healing in the natural beauty that surrounds him. He also crosses paths with a mysterious young woman who faces a dilemma as dire as his own. This beloved tale of hardship, nature, and renewal is rich in wisdom and the joy of being alive.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gene Stratton-Porter
      </h2>
      
      <p class="authorDescription body article">Gene Stratton-Porter was born and raised in Wabash County, Indiana. She was a self-trained American author, nature photographer, and naturalist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23778a84